import { MdUploadFile } from "react-icons/md";

function UploadFile({
  containerStyleForupload,
  textRowStyle,
  screenShoothandleFileChange,
  fileName,
  isScreenShootUploaded,
}) {
  return (
    <div style={containerStyleForupload}>
      {!isScreenShootUploaded ? (
        <>
          <div style={textRowStyle}>
            <label
              htmlFor="screenshot-upload"
              style={{
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: "8px",
                color: "#007BFF",
              }}
            >
              <MdUploadFile size={24} />
              <span>Upload Payment Screenshot</span>
            </label>
            <input
              type="file"
              id="screenshot-upload"
              accept="image/*"
              onChange={screenShoothandleFileChange}
              style={{ display: "none" }}
            />
          </div>
        </>
      ) : (
        <div style={{ marginTop: "8px", fontSize: "17px", color: "green" }}>
          Your Screenshot has been updated
        </div>
      )}

      {/* File name below the input */}
      {fileName && (
        <div style={{ marginTop: "8px", fontSize: "13px", color: "#555" }}>
          Selected file: <b>{fileName}</b>
        </div>
      )}
    </div>
  );
}

export default UploadFile;
